import React, {useEffect, useState} from "react";

import Card from "react-bootstrap/Card";

import "../styles/FarmNFT.css";

import LazyLoad from 'react-lazyload';

import Image from '../components/farm/Image';

import Logger from "../components/utils/Logger";

const NFT = ({id, uri}) => {
  const [metadata, setMetadata] = useState(null);

  useEffect(() => {
    Logger.log("useEffect loadNftMetadata");

    const loadNftMetadata = async () => {
      fetch(uri)
        .then(res => res.json())
        .then(
          (result) => {
            Logger.log("Loaded FarmNFT metadata", result);
            setMetadata(result);
          },
          (error) => {
            Logger.log(error);
          }
        );
    };

    loadNftMetadata();
  }, [uri]);

  if (!metadata) {
    return (
      <div>Loading NFT...</div>
    )
  }

  return (
    <LazyLoad once={true}>
      <div className="my-4">
        <Image id={id} image={metadata.image} nftName={metadata.name}/>
        <Card className="nft-card mx-auto">
          <Card.Body className="text-center">
            <Card.Title title="NFT name"><strong>{metadata.name}</strong></Card.Title>
            <Card.Text title="NFT description">{metadata.description}</Card.Text>
          </Card.Body>
        </Card>
      </div>
    </LazyLoad>
  )
};

export default NFT;